import EditSnack from "../EditSnack"
import '../styles/edit.css'

export default function Edit() {
  return (
   
  <div>
     <EditSnack/>
  </div>
  )
}
